
import ImageHeader from '@/components/core/ImageHeader';

export default {
  scrollToTop: true,
  components: {
    ImageHeader,
  },
  head() {
    return {
      title: "Search Engine Optimization Services - Goa App",
      meta: [{
        hid: 'description',
        name: 'description',
        content: 'Search Engine Optimization Services : We Are The Best in SEO.  Rank high in search engines and get more visitors with our SEO Services.'
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: 'seo, seo services, seo services in goa, search engine optimization, search engine optimization services, seo search engine optimization'
      },
      {
        hid: 'og:title',
        property: 'og:title',
        content: 'Search Engine Optimization Services - Goa App'
      },
      {
        hid: 'og:description',
        property: 'og:description',
        content: 'Search Engine Optimization Services : We Are The Best in SEO.  Rank high in search engines and get more visitors with our SEO Services.'
      },
      {
        hid: 'twitter:title',
        property: 'twitter:title',
        content: 'Search Engine Optimization Services - Goa App'
      },
      {
        hid: 'twitter:description',
        property: 'twitter:description',
        content: 'Search Engine Optimization Services : We Are The Best in SEO.  Rank high in search engines and get more visitors with our SEO Services.'
      },
      {
        hid: 'og:image:alt',
        property: 'og:image:alt',
        content: 'Search Engine Optimization Services - Goa App'
      },
      {
        hid: 'og:image',
        property: 'og:image',
        content: this.$config.siteUrl + '/img/service-imgs/search-engine-optimization.webp'
      },
      {
        hid: 'image',
        property: 'image',
        content: this.$config.siteUrl + '/img/service-imgs/search-engine-optimization.webp'
      },
      {
        hid: 'twitter-image',
        property: 'twitter:image',
        content: this.$config.siteUrl + '/img/service-imgs/search-engine-optimization.webp'
      },

      ],
    }
  },
  scrollToTop: true,
  data() {
    return {
      title: 'Search Engine Optimization Services - Goa App',
      description: 'Search Engine Optimization Services : We Are The Best in SEO.  Rank high in search engines and get more visitors with our SEO Services.',
      eventCategoryModal: false,
      schemaData: [],

      interLinks: {
        "title": "Explore More Services on Goa App",
        "links": [
          {
            "sub_title": "Top Services",
            "interLinks": [
              {
                "name": "Digital Marketing Services in Goa",
                "url": "/digital-marketing"
              },
              {
                "name": "Social Media Marketing in Goa",
                "url": "/social-media-marketing"
              },
              {
                "name": "Advertising in Goa",
                "url": "/advertising"
              },
              {
                "name": "Website Development in Goa",
                "url": "/website-development"
              },
              {
                "name": "Graphic Designing in Goa",
                "url": "/graphic-design"
              },
              {
                "name": "Influencer Marketing in Goa",
                "url": "/influencer-marketing"
              },
              {
                "name": "Content Marketing in Goa",
                "url": "/content-marketing"
              }

            ]
          },
        ]
      }
    };
  },

jsonld() {
    return {
        '@context': 'https://schema.org',
        "@graph": [
            {
                "@type": "Service",
                "@id": "https://goa.app/search-engine-optimization/#Service",
                "url": "https://goa.app/search-engine-optimization",
                "name": "Search Engine Optimization",
                "description": "We Are The Best in SEO. Rank high in search engines and get more visitors with our Search Engine Optimization Services.",
                "image": "https://goa.app/img/service-imgs/search-engine-optimization.webp",
                "inLanguage": "en-US",
                "datePublished": "2024-06-14T00:00:00",
                "dateModified":  "2024-06-14T00:00:00",
                "author": {
                    "@type": "Person",
                    "@id": "https://goa.app",
                    "url": "https://goa.app"
                },
                "serviceType": "Digital Marketing",
                "provider": {
                    "@type": "Corporation",
                    "name": "Goa App",
                    "address": {
                        "@type": "PostalAddress",
                        "addressLocality": "Goa",
                        "postalCode": "403505"
                    },
                    "telephone": "+91 9049248689"
                },
                "priceRange": "₹₹",
                "hasOfferCatalog": {
                    "@type": "OfferCatalog",
                    "name": "Search Engine Optimization",
                    "itemListElement": [
                        {
                            "@type": "Offer",
                            "name": "Technical SEO"
                        },
                        {
                            "@type": "Offer",
                            "name": "Mobile-First Strategy"
                        },
                        {
                            "@type": "Offer",
                            "name": "Hyper-Local SEO"
                        },
                        {
                            "@type": "Offer",
                            "name": "Penalty Recovery"
                        },
                        {
                            "@type": "Offer",
                            "name": "Site Migration"
                        },
                        {
                            "@type": "Offer",
                            "name": "Information Architecture Development"
                        },
                        {
                            "@type": "Offer",
                            "name": "Content Strategy"
                        },
                        {
                            "@type": "Offer",
                            "name": "Competitive Auditing"
                        },
                        {
                            "@type": "Offer",
                            "name": "Sustainable High Performance"
                        }
                    ]
                }
            },
            {
                "@type": "FAQPage",
                "mainEntity": [
                    {
                        "@type": "Question",
                        "name": "How does SEO work?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "SEO improves your website's visibility in search engine results by optimizing content, technical aspects, and external factors like backlinks, making it easier for search engines to understand and rank your site for relevant queries. We can audit your site, implement SEO best practices, and monitor performance to ensure long-term visibility."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Can SEO increase my sales and leads?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, SEO can significantly increase sales and leads by driving targeted traffic to your website through improved visibility in search results, attracting users who are actively searching for your products or services. We specialize in optimizing SEO strategies tailored to your business goals, ensuring maximum ROI from organic search traffic."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "If I stuff enough keywords on my website, will it rank?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Keyword stuffing can harm your rankings. Search engines prioritize user experience and quality content. Focus on using keywords naturally and creating valuable content that addresses user needs. We focus on strategic keyword placement and creating valuable content that resonates with your audience, improving both rankings and user experience."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "How long will it take for my website to rank?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Ranking timelines vary based on factors like competition, keyword difficulty, and the effectiveness of your SEO efforts. Generally, noticeable improvements can take several months, with ongoing optimization yielding long-term results. We develop customized SEO plans with clear milestones and continuous optimization to achieve sustainable ranking improvements over time."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Should I outsource my SEO or do it myself?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Outsourcing SEO to experts can provide specialized knowledge, resources, and consistent results, allowing you to focus on your core business activities while ensuring effective SEO strategies are implemented. Outsourcing SEO to our experienced team ensures comprehensive strategy development and execution. We stay updated on industry trends, implement best practices, and deliver measurable results, allowing you to focus on your core business."
                        }
                    },
                    {
                        "@type": "Question",
                        "name": "Will I have to make changes to my website?",
                        "acceptedAnswer": {
                            "@type": "Answer",
                            "text": "Yes, SEO often involves making technical and content improvements to your website, such as optimizing meta tags, improving site speed, enhancing mobile responsiveness, and creating high-quality, relevant content. We conduct thorough website audits, recommend necessary improvements, and handle implementation to enhance your site's SEO performance."
                        }
                    }
                ]
            }
        ]
    };
},


  mounted() {
    document.body.classList.add('modalOverflow');

    this.getHomeActitvitesData();
    this.getActitvitesData();
    this.getActitvitesCategoriesData();

    if (localStorage.getItem('recentlyViewed')) {
      this.recentlyViewed = JSON.parse(localStorage.getItem('recentlyViewed'))
    }

    if (localStorage.getItem('activitiesFilter')) {
      localStorage.removeItem('activitiesFilter');
    }
    this.$parent.$emit("sentInterLinks", this.interLinks);
  },

  destroyed() {
    document.body.classList.remove('modalOverflow')
    if (document.getElementById('filterClose'))
      document.getElementById('filterClose').click();
  },

  methods: {
    async getHomeActitvitesData() {
      this.allHomeActivitiesData = await fetch(this.$config.fetchUrl +
        '/api/posts/app/getActivitiesForActivityPageWithSlug').then(res => res
          .text());
      this.allHomeActivitiesData = this.getCryptKey(this.allHomeActivitiesData);
      this.homeactLoading = false;
      this.$nextTick(() => {
        if (this.allHomeActivitiesData) {
          var schemaResult = Object.keys(this.allHomeActivitiesData).map((key) => [this.allHomeActivitiesData[
            key].data]);
          schemaResult = schemaResult.flat(2);
          this.schemaData = [...new Map(schemaResult.map(v => [v.post._id, v])).values()]
        }
      })
      //this.changeThingsToDo(0)
    },

    async getActitvitesData() {
      this.allActivitiesData = await fetch(this.$config.fetchUrl + '/api/coupons/app/featuredCoupons').then(res =>
        res
          .text());
      this.allActivitiesData = this.getCryptKey(this.allActivitiesData);
      this.actLoading = false;
      // this.$nextTick(() => {
      //   if (this.allHomeActivitiesData) {
      //     this.schemaData = [...this.allHomeActivitiesData.featuredActivities, ...this.allHomeActivitiesData.photography, ...this.allHomeActivitiesData.hiddenGems];
      //     this.schemaData = [...new Map(this.schemaData.map(v => [v.post._id, v])).values()]
      //   }
      // })
    },

    async getActitvitesCategoriesData() {
      this.featuredCatsLoading = true;
      this.featuredCats = await fetch(this.$config.fetchUrl + '/api/posts/app/getCategoriesForActivityPageWithSlug').then(res =>
        res
          .text());
      this.featuredCats = this.getCryptKey(this.featuredCats);
      this.featuredCatsLoading = false;
    },

    changeThingsToDo(id) {
      switch (id) {
        case 0:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
          break;
        case 1:
          this.thingsToDo = this.allHomeActivitiesData.photography;
          break;
        case 2:
          this.thingsToDo = this.allHomeActivitiesData.hiddenGems;
          break;
        case 3:
          this.thingsToDo = this.allHomeActivitiesData.specialMoments;
          break;
        case 4:
          this.thingsToDo = this.allHomeActivitiesData.monsoonActivities;
          break;
        default:
          this.thingsToDo = this.allHomeActivitiesData.featuredActivities;
      }
    },

    getSpace(key) {
      return key.replace(/([A-Z])/g, " $1")
    },

    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return '';
      }
    },

    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/places.svg`)
    },

    activityVenue(seller) {
      if (seller && seller.length > 0 && seller[0].venue) {
        return seller[0].venue.name
      }
      return ""
    },

    activityDuration(seller) {
      if (seller && seller.length > 0 && seller[0].durationInHours) {
        return seller[0].durationInHours
      }
      return ""
    },

    activityPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].strikePrice) {
        return seller[0].tickets[0].prices[0].strikePrice
      }
      return 0
    },

    activityDiscountPrice(seller) {
      if (seller && seller.length > 0 && seller[0].tickets && seller[0].tickets.length > 0 && seller[0].tickets[0]
        .prices && seller[0].tickets[0].prices.length > 0 && seller[0].tickets[0].prices[0].price) {
        return seller[0].tickets[0].prices[0].price
      }
      return 0
    },

    checkIsOffer(seller) {
      let strikePrice = this.activityPrice(seller);
      let price = this.activityDiscountPrice(seller);
      if (strikePrice > price) {
        return true
      }
      return false
    },

    offerPercentage(seller) {
      if (this.checkIsOffer(seller)) {
        let strikePrice = this.activityPrice(seller);
        let price = this.activityDiscountPrice(seller);
        let offerPercentage = strikePrice - price;
        if (offerPercentage > 0) {
          return ((100 * (strikePrice - price) / strikePrice) > 0 && (100 * (strikePrice - price) /
            strikePrice) < 100) ? parseFloat((100 * (strikePrice - price) / strikePrice).toFixed(0)) : 0
        } else return 0
      }
      return 0
    },

    categoryBtnClicked(item) {
      if (item) {
        this.$router.push({
          path: item
        })
      }
    },

  }
}
